
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
import { Marca } from '@/__env/lib/Articulos/Marcas';
import { Sector } from '@/__env/lib/Articulos/Sectores';
import { Linea } from '@/__env/lib/Articulos/Lineas';
import { Titulo } from '@/__env/lib/Articulos/Titulos';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            this.Iniciar();
        }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Iniciar();
        }

        Iniciar()
        {
            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Filtros[key] = Number( this.Buscador.Filtros.Valores[key] );
            }
            //this.Transporte = this.Buscador.Filtros.Valores.Logistica;
        }


        public Titulo: Titulo = null;
        public Linea: Linea = null;
        public Sector: Sector = null;
        public Marca: Marca = null;

        public Filtros: Record<string, number> = {
            Tipo: 0,
            Limite: 1,
            Orden: 0,
            Indice: 0,
        };

        public async Filtrar()
        {
            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Buscador.Filtros.Valores[key] = this.Filtros[key];
            }


            this.Buscador.Filtros.Valores.Titulo = this.Titulo;
            this.Buscador.Filtros.Valores.Sector = this.Sector;
            this.Buscador.Filtros.Valores.Linea = this.Linea;
            this.Buscador.Filtros.Valores.Marca= this.Marca;

            await this.Buscador.Buscar( 1 );
            this.Cerrar();
        }

        Cerrar()
        {
            this.Abierto = false;
            this.Controlador.Vista.Filtros.Abierto = false;
        }


        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
